import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import {
  CLEAR_HABITATIONAL_QUOTE_STATE,
  
  FETCH_HABITATIONAL_QUOTE_FAILED,
  FETCH_HABITATIONAL_QUOTE_LIST_FAILED,
  FETCH_HABITATIONAL_QUOTE_LIST_PROGRESS,
  FETCH_HABITATIONAL_QUOTE_LIST_SUCCESS,
  FETCH_HABITATIONAL_QUOTE_PROGRESS,
  FETCH_HABITATIONAL_QUOTE_SUCCESSS,
} from "./habitationalQuoteActions";
import { initialHabitationalQuoteState } from "./habitationalQuote.types";
import { HabitationalQuoteActions } from ".";

export const HabitationalQuoteReducer = (
  state: IStoreState["habitational"]["quote"] = initialHabitationalQuoteState,
  action: HabitationalQuoteActions
) => {
  switch (action.type) {

	case FETCH_HABITATIONAL_QUOTE_PROGRESS: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.InProgress;
		draftState.data =
		  initialHabitationalQuoteState["data"];
	  });
	  return newState;
	}
	case FETCH_HABITATIONAL_QUOTE_SUCCESSS: {
	  const { data } = action.payload;
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Loaded;
		draftState.data = data;
	  });
	  return newState;
	}
	case FETCH_HABITATIONAL_QUOTE_FAILED: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Failed;
		draftState.data =
		  initialHabitationalQuoteState["data"];
	  });
	  return newState;
	}

	case FETCH_HABITATIONAL_QUOTE_LIST_PROGRESS: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.InProgress;
		draftState.list = [];
	  });
	  return newState;
	}
	case FETCH_HABITATIONAL_QUOTE_LIST_SUCCESS: {
	  const { data } = action.payload;
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Loaded;
		draftState.list = data;
	  });
	  return newState;
	}
	case FETCH_HABITATIONAL_QUOTE_LIST_FAILED: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Failed;
		draftState.list = [];
	  });
	  return newState;
	}

	case CLEAR_HABITATIONAL_QUOTE_STATE: {
	  return initialHabitationalQuoteState;
	}

	default: {
	  return state;
	}
  }
};
